import { CustomSearch } from 'components/CustomSearch'

import styled from 'styled-components'

export const Search = ({
  data,
  handleOnSelect,
  handleOnFocus,

  labels,

  small = false,
}: {
  data: { id?: number | string; name: string; [key: string]: any }[]
  handleOnSelect: (item: any) => void
  handleOnFocus?: () => void

  labels?: {
    placeholder: string
    noResults?: string
    clear?: string
  }

  small?: boolean
}) => {
  return (
    <SearchRoot small={small}>
      <CustomSearch
        data={data}
        filterType={'include'}
        maxResults={8}
        handleSelect={handleOnSelect}
        handleFocus={handleOnFocus}
        small={small}
        labels={labels}
      />
    </SearchRoot>
  )
}

const SearchRoot = styled.div<{ small: boolean }>`
  /* margin-bottom: 60px; */
  font-size: 12px;

  /* width: 100%; */
  font-size: 22px !important;
  /* margin-bottom: 30px; */



`

const SearchResult = styled.span`
  pointer-events: all;
`
